import { Subject } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/services/loader/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {

  constructor(private loaderService: LoaderService) { }
  color = 'primary';
  mode = 'indeterminate';
  value = 10;
  isLoading: Subject<boolean> = this.loaderService.isLoading;

  ngOnInit() {
  }

}
